var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../../assets/images/seal/success.png"),"alt":""}}),_c('p',{staticClass:"suText"},[_vm._v("提交成功")]),_c('p',{staticClass:"moText"},[_vm._v("您可回到网页端继续操作")])])
}]

export { render, staticRenderFns }